var toString = require('../internals/object-to-string');

// `Object.prototype.toString` method
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
if (toString !== ({}).toString) {
  require('../internals/redefine')(Object.prototype, 'toString', toString, true);
}



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/modules/es.object.to-string.js
// module id = 193
// module chunks = 0